<template>
  <v-card class="mb-2 card-mensagem">
    <v-card-title class="titulo-card">
      {{ mercado.dsMercadoDestino}}
    </v-card-title>
    <v-card-text class="pb-0">
      <v-form ref="formMensagem">
        <div class="mensagem-card-mercado-destino mb-2 pa-2" v-for="mensagem in mercado.mensagensBoletimSanitario"
             :key="`mensagem__${mensagem.idMensagemBoletimSanitario}__${mercado.idMercadoDestino}`" >
          <pre class="mensagem-text">{{ mensagem.dsMensagemBoletimSanitario }}</pre>
        </div>
      </v-form>
    </v-card-text>
    <v-card-actions class="pt-0">
      <v-spacer />
      <confirmation-dialog :item="mercado" deletar @confirmed="deletarMercado"
                       titulo="Deletar mercado destino"
                       ds-acao="Deseja mesmo deletar o mercado destino?"
                       mensagem="Ao deletar esse mercado destino todos os boletins sanitários que o utilizam serão alterados.">
        <template v-slot:activator="{ on }">
          <v-btn color="#799596" text v-on="on" :retain-focus-on-click="false">
            DELETAR
          </v-btn>
        </template>
      </confirmation-dialog>
      <v-btn color="#00A5A2" text :to="`/detalheMercadoDestino/${mercado.idMercadoDestino}`"
             :retain-focus-on-click="false">
        EDITAR
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ConfirmationDialog from "../ConfirmationDialog";
export default {
  name: "MercadoDestinoCard",
  components: {ConfirmationDialog},
  props: {
    mercado: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    deleting: false,
  }),
  methods: {
    deletarMercado() {
      this.$axios.delete(`mercado-destino/${this.mercado.idMercadoDestino}`)
          .catch(error => {
            this.$store.commit("setSnack", {type: "error", msg: error})
          })
      this.$emit('deletarMercado')
    },
  },
}
</script>

<style scoped>
.titulo-card {
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 23px;
  letter-spacing: 0.15px;
  color: #35565B;
}

.mensagem-text {
  font: normal normal normal 16px/28px Roboto, sans-serif;
  color: rgba(0, 0, 0, 0.87);
  letter-spacing: 0;
  white-space: pre-wrap;
}

.mensagem-card-mercado-destino {
  background: #F2F5F3;
  border: 1px solid #0090E9;
  box-sizing: border-box;
  border-radius: 4px;
}

</style>